import { useEffect, useRef, useState } from 'react';

export default function Reveal({ as: Tag = 'div', className = '', delay = 0, children, ...props }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    // Respect reduced-motion: show immediately, no observer overhead
    if (typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setShown(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Defer state set into next animation frame so we don't
          // block scroll/reflow in the observer callback.
          const id = window.requestAnimationFrame(() => {
            window.setTimeout(() => setShown(true), delay);
          });
          io.disconnect();
          return () => window.cancelAnimationFrame(id);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' },
    );
    io.observe(node);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag
      ref={ref}
      className={`bb-reveal ${shown ? 'bb-in' : ''} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
}
